import AdminManagementLayout from "components/layouts/AdminManagementLayout";
import MasterLayout from "components/layouts/MasterLayout";
import {LoadingBarProcess} from "components/loadingProcess/LoadingBarProcess";
import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {RequireAuth} from "./Routes";

const AdminList = React.lazy(() => import("pages/adminManagement/admin/AdminList"));
const EventList = React.lazy(() => import("pages/adminManagement/event/EventList"));
const LogList = React.lazy(() => import("pages/adminManagement/log/LogList"));
const PendingUserApprovalList = React.lazy(() => import("pages/adminManagement/user/PendingUserApprovalList"));
const ListUsers = React.lazy(() => import("pages/adminManagement/user/ListUsers"));
const DetailAdmin = React.lazy(() => import("pages/adminManagement/admin/DetailAdmin"));
const DetailUser = React.lazy(() => import("pages/adminManagement/user/DetailUser"));
const ListGeneration = React.lazy(() => import("pages/adminManagement/generation/ListGeneration"));
const IPassword = React.lazy(() => import("pages/adminManagement/iPassword/IPassword"));
const ImportUser = React.lazy(() => import("pages/adminManagement/importUser/ImportUser"));

const AdminManagementRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MasterLayout/>}>
                {/* `/quan-ly` on its own matched no child, so it rendered the
                    header, the banner and the footer with nothing in between and
                    no menu to get anywhere from -- a dead end for anyone who
                    typed or bookmarked it. It goes where the "Quản lý" item in
                    the main nav goes. */}
                <Route index element={<Navigate to='/quan-ly/user-detail' replace/>}/>
                <Route
                    path='/user-detail'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailUser/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/user-detail/:id'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailUser/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/pending-user-approval/user-detail/:id'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailUser/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/pending-user-approval'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <PendingUserApprovalList/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/list-users'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <ListUsers/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/list-users/user-detail/:id'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailUser/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/admin-detail/:id'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailAdmin/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/admin-detail'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <DetailAdmin/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path='/log'
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <LogList/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path="/event"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <EventList/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path="/event/:id"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <EventList/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path="/admin"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <AdminList/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path="/gerenation"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <ListGeneration/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                <Route
                    path="/ipassword"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <IPassword/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                 <Route
                    path="/import-user"
                    element={
                        <React.Suspense fallback={<LoadingBarProcess/>}>
                            <RequireAuth>
                                <AdminManagementLayout>
                                    <ImportUser/>
                                </AdminManagementLayout>
                            </RequireAuth>
                        </React.Suspense>
                    }
                />
                {/* An unknown path under `/quan-ly` matched nothing here, and the
                    app's `*` route lives in the parent Routes, which had already
                    handed the URL over -- so a mistyped admin address rendered a
                    blank white page rather than the 404. */}
                <Route path='*' element={<Navigate to='/404' replace/>}/>
            </Route>
        </Routes>
    );
};

export default AdminManagementRoutes;
